import React, { ReactElement } from 'react'
import {
  FormControl as ChakraFormControl, FormControlProps, FormErrorMessage, FormErrorMessageProps, FormHelperText,
  FormLabel, FormLabelProps, HelpTextProps
} from '@chakra-ui/react'
import { useField } from 'formik'

export interface BaseProps extends Omit<FormControlProps, 'label'> {
  name: string;
  label?: React.ReactNode;
  inputType?: 'default' | 'password' | 'phone' | 'rut' | 'contact'
  availableElements?: boolean
  SelectionElement?: ReactElement[]
  handleOnChange?: (value: string) => void
  labelProps?: FormLabelProps;
  helperText?: React.ReactNode;
  helperTextProps?: HelpTextProps;
  errorMessageProps?: FormErrorMessageProps;
}

export const FormControl: React.FC<BaseProps> = (props: BaseProps) => {
  const {
    children,
    name,
    label,
    labelProps,
    helperText,
    helperTextProps,
    errorMessageProps,
    ...rest
  } = props
  const [, { error, touched }] = useField(name)

  return (
    <ChakraFormControl isInvalid={!!error && touched} {...rest}>
      {label && typeof label === 'string' ? (
        <FormLabel htmlFor={name} {...labelProps}>
          {label}
        </FormLabel>
      ) : (
        label
      )}
      {children}
      {error && (
        <FormErrorMessage {...errorMessageProps}>{error}</FormErrorMessage>
      )}
      {helperText && typeof helperText === 'string' ? (
        <FormHelperText {...helperTextProps}>{helperText}</FormHelperText>
      ) : (
        helperText
      )}
    </ChakraFormControl>
  )
}

export default FormControl
